import React from 'react'

const JS_Essentials_Coding_Pratice_9 = () => {
  return (
    <div>
      <h1>Coding Practice 9</h1>
    </div>
  )
}

export default JS_Essentials_Coding_Pratice_9
